// Third-party Imports
import styled from '@emotion/styled';

// Config Imports
import themeConfig from '../../../configs/themeConfig';

// Util Imports
import { commonLayoutClasses } from '../../utils/layoutClasses';

type StyledMainProps = {
  isContentCompact: boolean;
};

const StyledMain = styled.main<StyledMainProps>`
  ${({ isContentCompact }) =>
    isContentCompact &&
    `
    margin-inline: auto;
    max-inline-size: ${themeConfig.compactContentWidth}px;
  `}

  &:has(.${commonLayoutClasses.contentHeightFixed}) {
    display: flex;
    overflow: hidden;
    flex-direction: column;
  }
`;

export default StyledMain;
